/**
 * Sets a property value into the original object
 * @param entity original object
 * @param path Path to the property (example: "items[0].price.currency"). Assumes that numbers are array indexes.
 * @param value new value
 * @param cloneUpdatedPath If set to true, will create an updated clone (but only in the updated path)
 * @returns
 */
const DotOrOpeningBracket = /\.|\[/

type UpdatableObject = Array<any> | Record<string, any>

function parseKeyAsInt(str) {
  return /^\d+$/.test(str) ? parseInt(str) : Number.NaN
}
const updateObjectPath = function <E extends UpdatableObject>(
  entity: E,
  path: string,
  value: any,
  cloneUpdatedPath = false
): E {
  if (path.startsWith('.')) path = path.slice(1)

  let nextPath = path.slice(1).search(DotOrOpeningBracket)
  if (nextPath >= 0) {
    nextPath++
  }
  let currentKey: string = nextPath >= 0 ? path.slice(0, nextPath) : path
  const remainingPath = nextPath >= 0 ? path.slice(nextPath) : undefined
  if (currentKey[0] == '[' && currentKey.endsWith(']'))
    currentKey = JSON.parse(currentKey.slice(1, currentKey.length - 1))

  const currentIndex = parseKeyAsInt(currentKey)
  const isArray = Array.isArray(entity)

  const cloneOrOriginalOrNew: E = (entity == null
    ? isNaN(currentIndex)
      ? {}
      : []
    : !cloneUpdatedPath
    ? entity
    : isArray
    ? [...(entity as Array<any>)]
    : { ...entity }) as unknown as E
  cloneOrOriginalOrNew[currentKey] =
    nextPath >= 0
      ? updateObjectPath(
          cloneOrOriginalOrNew[isArray ? currentIndex : currentKey],
          remainingPath,
          value,
          cloneUpdatedPath
        )
      : value
  return cloneOrOriginalOrNew
}

export default updateObjectPath
